export type Unit = "in" | "ft" | "cm" | "m" | "yd";

export const conversionRates: Record<Unit, Record<Unit, number>> = {
	in: { in: 1, ft: 1 / 12, cm: 2.54, m: 0.0254, yd: 1 / 36 },
	ft: { in: 12, ft: 1, cm: 30.48, m: 0.3048, yd: 1 / 3 },
	cm: { in: 1 / 2.54, ft: 1 / 30.48, cm: 1, m: 1 / 100, yd: 1 / 91.44 },
	m: { in: 39.37, ft: 3.281, cm: 100, m: 1, yd: 1.094 },
	yd: { in: 36, ft: 3, cm: 91.44, m: 0.9144, yd: 1 }
};

export const unitFullNames: Record<Unit, string> = {
	in: "Inch",
	ft: "Foot",
	cm: "Cm",
	m: "Meter",
	yd: "Yard"
};

export type VolumeUnit = "in³" | "ft³" | "cm³" | "m³" | "yd³";

export const volumeConversionRates: Record<VolumeUnit, Record<VolumeUnit, number>> = {
	"in³": { "in³": 1, "ft³": 1 / 1728, "cm³": 16.3871, "m³": 1 / 61023.7, "yd³": 1 / 46656 },
	"ft³": { "in³": 1728, "ft³": 1, "cm³": 28316.8466, "m³": 1 / 35.315, "yd³": 1 / 27 },
	"cm³": { "in³": 1 / 16.3871, "ft³": 1 / 28316.8466, "cm³": 1, "m³": 1 / 1000000, "yd³": 1 / 764554.858 },
	"m³": { "in³": 61023.7, "ft³": 35.315, "cm³": 1000000, "m³": 1, "yd³": 1.308 },
	"yd³": { "in³": 46656, "ft³": 27, "cm³": 764554.858, "m³": 1 / 1.308, "yd³": 1 }
};

export const volumeUnitFullNames: Record<VolumeUnit, string> = {
	"in³": "Inch³",
	"ft³": "Foot³",
	"cm³": "Cm³",
	"m³": "Meter³",
	"yd³": "Yard³"
};

export const conversionFactors = {
    in: 0.0254,
    cm: 0.01,
    ft: 0.3048,
    yd: 0.9144,
    m: 1
};

export const conversionText = {
    in: `"`,
    cm: "cm",
    ft: "'",
    yd: "yd",
    m: "m"
};


export const kmToMile = 0.621371


